








































































import { AwsService as awsApi } from "@/common/api/services/AwsService";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import chunk from "lodash/chunk";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

Dropzone.autoDiscover = false;

@Component({
  name: "uploadFile",
  components: {},
})
export default class uploadFile extends Vue {
  @Prop({ default: true })
  public showDefault: boolean;
  @Prop({
    default: () => {
      return {
        uploadMultiple: false,
      };
    },
  })
  public options;

  @Prop({ default: false })
  public isSpecialValidate;

  @Prop({ default: false })
  public preventDuplicateName;

  @Prop({
    default: () => [],
  })
  public files;

  @Prop({ default: false })
  public allowSequentialNumbering;

  public selfFiles = [];
  public errors = [];

  public dropzone;

  public queueUploaded = [];
  public loader: any;

  @Prop({
    default: () => 1,
  })
  public maxFiles: number;

  public fileErrors = [];

  public localOptions: any = {};
  @Watch("files")
  public watchFileInput() {
    this.selfFiles = [...this.files].map((item) => {
      item.fullUrl = this.formatUrl(item.name);
      return item;
    });
  }
  public mounted() {
    this.selfFiles = [...this.files].map((item) => {
      item.fullUrl = this.formatUrl(item.name);
      return item;
    });
    const localOptions = {
      // The URL will be changed for each new file being processing
      url: "/",
      // Since we're going to do a `PUT` upload to S3 directly
      method: "PUT",
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        const _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 10,
      autoProcessQueue: true,
      maxFiles: this.maxFiles,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: "",
      // Customize the wording
      dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
      // We're going to process each file manually (see `accept` below)
      // Here we request a signed upload URL when a file being accepted
      accept: async (file, done) => {
        // const extension = file.name.split(".").pop();
        // const result = await awsApi.awsUploadPresign({
        //   fileName: file.upload.uuid + "." + extension,
        //   disabledLoadinng: true,
        // } as any);
        // file.uploadURL = result.data.presign.url;
        // (file.filePath = file.upload.uuid + "." + extension), done();
        // this.dropzone.processFile(file);
      },
    };
    // Instantiate Dropzone
    this.localOptions = { ...localOptions };
    this.dropzone = new Dropzone(this.$el, {
      ...localOptions,
      ...this.options,
    });
    this.addListenForDropzone();
  }

  public addListenForDropzone() {
    this.dropzone.on("addedfiles", async (files) => {
      if (this.files.length + files.length > this.maxFiles) {
        this.errors.push(
          `ファイルアップロード数 は最大 ${this.maxFiles}枚 です。`,
        );
        for (const item of files) {
          this.dropzone.removeFile(item);
        }
        this.$emit("pushError", this.errors);
        return;
      }

      if (this.options.maxFilesize) {
        for (const file of files) {
          if (file.size > this.options.maxFilesize * 1024 * 1024) {
            return;
          }
        }
      }

      if (this.preventDuplicateName) {
        const arrayFiles: any = Object.values(files) ?? [];
        if (this.allowSequentialNumbering) {
          if (
            this.files
              .map((item) => item.upload.filename ?? item.name)
              .some((item) =>
                arrayFiles.map((file) => file.name).includes(item),
              )
          ) {
            this.errors.push(
              "同じ画像が登録されています。アップロード済みの画像を確認するかファイル名を変更してください。",
            );
            for (const item of files) {
              this.dropzone.removeFile(item);
            }
            this.$emit("pushError", this.errors);
            return;
          }
          const arrayNameFiles = [];
          for (const item of files) {
            const filename = item.originalName ?? item.name;
            const firstPart = filename.slice(
              0,
              Math.max(0, filename.indexOf(".")),
            );
            const extension = filename.slice(
              Math.max(0, filename.indexOf(".")),
              filename.length,
            );
            if (!firstPart.includes("_01")) {
              const newName = `${firstPart}_01${extension}`;
              if (arrayNameFiles.includes(newName)) {
                this.errors.push(
                  "同じ画像が登録されています。アップロード済みの画像を確認するかファイル名を変更してください。",
                );
                for (const item of files) {
                  this.dropzone.removeFile(item);
                }
                this.$emit("pushError", this.errors);
                return;
              }
              arrayNameFiles.push(newName);
            } else {
              arrayNameFiles.push(filename);
            }
          }
        }
        if (
          this.files
            .map((item) => item.originalName ?? item.name)
            .some((item) => arrayFiles.map((file) => file.name).includes(item))
        ) {
          this.errors.push(
            "同じ画像が登録されています。アップロード済みの画像を確認するかファイル名を変更してください。",
          );
          for (const item of files) {
            this.dropzone.removeFile(item);
          }
          this.$emit("pushError", this.errors);
          return;
        }
      }

      if (this.isSpecialValidate) {
        for (const file of files) {
          this.addFile(file);
        }
        this.$emit("changed", this.selfFiles);
        this.$emit("specialValidate");
        return;
      }

      this.uploadToS3(files);
      // this.dropzone.processFile(files[0]);
    });
    // Set signed upload URL for each file
    this.dropzone.on("processing", (file) => {
      this.dropzone.options.url = file.uploadURL;
    });
    this.dropzone.on("success", (file) => this.uploadSuccessed(file));
    this.dropzone.on("uploadprogress", (file) => {
      this.$emit("uploading", true);

      this.addFile(file);
    });
    this.dropzone.on("error", (file, message) =>
      this.handelError(file, message),
    );
    this.dropzone.on("queuecomplete", () => {
      this.$emit("uploading", false);
    });
  }

  public async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public async uploadToS3(files) {
    const fileList: any = chunk(files, 10);
    for (const items of fileList) {
      const result = await awsApi.awsUploadFilePresignMulty({
        disabledLoadinng: false,
        fileList: items.map((file: any) => {
          const extension = file.name.split(".").pop();
          return {
            fileName: `${file.upload.uuid}.${extension}`,
            uuid: file.upload.uuid,
            extension,
          };
        }),
      } as any);

      if (!result.errors) {
        for (const item of items) {
          const extension = item.name.split(".").pop();
          item.uploadURL = result.data.list.find(
            (url) => url.uuid === item.upload.uuid,
          ).presignUrl;
          item.filePath = `${item.upload.uuid}.${extension}`;
          item.extension = extension;
          item.mimeType = item.type;
          this.dropzone.processFile(item);
        }
      }
    }
  }

  public formatUrl(fileName) {
    return fileName;
    // return formatImageUrl(fileName);
  }

  public open() {
    this.errors = [];
    this.dropzone.hiddenFileInput.click();
  }

  public handelError(file, comment = "") {
    let message = comment;
    if (
      this.options.acceptedFiles &&
      !this.options.acceptedFiles.includes(file.type.split("/")[1])
    ) {
      const acceptFileTypes = this.options.acceptedFiles
        .trim()
        .replace(/\s*,\s*/g, "")
        .replace(/\.(jpg|jpeg|png|mp4|pdf)/g, "$1・")
        .slice(0, -1);
      message = `アップロード可能な画像形式は${acceptFileTypes}になります`;
    }
    if (file.size > this.options.maxFilesize * 1024 * 1024) {
      message = `アップロード可能なサイズは ${this.options.maxFilesize}MB以下 になります`;
    }
    if (message === "Server responded with 0 code.") {
      message =
        "アップロード中にオフラインになりました。再度アップロードしてください";
      this.errors.push(`${file.name}: ${message}`);
      this.$emit("pushError", this.errors);
      return;
    }

    this.errors.push(`${file.name}: ${message} (Removed)`);
    this.$emit("pushError", this.errors);
    this.dropzone.removeFile(file);
  }

  public async addFile(file) {
    // file.loading && file.loading.hide();
    let findFile = this.selfFiles.find(
      (item) => item.upload && item.upload.uuid === file.upload.uuid,
    );
    if (findFile) {
      findFile = file;
    } else {
      if (file.status !== "error") {
        this.selfFiles.push(file);
      }
    }

    this.reRender();
    // (this.$refs.imgBlock as HTMLElement).scrollTop = (
    //   this.$refs.imgBlock as HTMLElement
    // ).scrollHeight;
  }

  public uploadSuccessed(file) {
    // call api add file
    this.reRender();
    this.queueUploaded.push(file);
    const totalSuccess = this.dropzone.files.filter(
      (file) => file.status === "success",
    ).length;

    if (totalSuccess === this.dropzone.files.length) {
      // this.$emit("uploading", false);
      this.triggerCreateData();
      this.$emit("allow-create", true);
    }

    this.$emit("successUpload", file);
  }

  public async triggerCreateData() {
    if (this.loader) {
      this.loader.hide();
    }
    this.$emit("uploading", false);
    this.$emit("changed", this.selfFiles);
  }

  public reRender() {
    this.selfFiles.unshift({ w: 1 });
    this.selfFiles.shift();
  }

  public removeFile(file, index) {
    if (file.upload) {
      // instance of file
      this.dropzone.removeFile(file);
    }
    this.selfFiles.splice(index, 1);
    this.$emit("changed", this.selfFiles);
    this.$emit("specialValidate");
  }

  public reCreateDropzone() {
    this.dropzone.destroy();
    this.dropzone = new Dropzone(this.$el, {
      ...this.localOptions,
      ...this.options,
    });
    this.addListenForDropzone();
  }

  public reset() {
    if (this.selfFiles.length > 0) {
      for (const file of this.selfFiles) {
        this.dropzone.removeFile(file);
      }
    }
    this.selfFiles = [];
  }

  get isLoading(): boolean {
    return this.selfFiles?.some((item) => item.status === "uploading");
  }
}
